var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 32.5,
    r: 30.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20B8E9",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 2.88,
    d: "m39.22 11 1.428 1.704.234.289c.253.322.559.741.865 1.218.268.418.502.828.692 1.227a6.3 6.3 0 0 1 .122.27c.521 1.211.857 2.677.931 4.008.093 1.66-.025 3.536-.405 5.961.15.14.283.305.392.496.5.872.476 2.173.01 4.18-.398 1.714-.765 2.702-1.267 3.25-.2.217-.438.384-.699.486-.13.461-.273.918-.427 1.356-.317.9-.652 1.65-1.034 2.232l-.005.071c-.028.483-.037.968-.026 1.452.83.222 1.452.665 1.627 1.594l.21 1.095c.252 1.263.366 1.49.779 1.803l.288.208.272.183c.835.535 2.043 1.022 8.81 3.698.51.202.948.542 1.334 1.005.683-.055 1.373.25 1.918.9.495.592-.93.554-.54 1.774C48.105 58.23 41.81 62.174 31.5 62.174c-8.528 0-13.042-3.517-19.442-7.24L9.901 53.24c.658-2.193.404-1.386 1.071-2.474.58-1.49 1.443-2.553 2.535-2.986l4.423-1.764c2.865-1.163 3.757-1.6 4.398-2.073l.236-.175c.419-.296.356-.186.881-2.974.175-.93.8-1.373 1.628-1.595l.002-.075c.009-.483-.002-.966-.033-1.448-.382-.583-.717-1.332-1.034-2.231-.156-.448-.299-.9-.428-1.357a1.887 1.887 0 0 1-.698-.487c-.472-.515-.825-1.42-1.197-2.955l-.07-.295c-.465-2-.49-3.301.002-4.17a2.34 2.34 0 0 1 .302-.423 35.688 35.688 0 0 1-.156-.744 26.217 26.217 0 0 1-.399-2.703 13.582 13.582 0 0 1-.037-2.215c.18-2.37 1.315-4.003 3.142-5.178.246-.158.494-.302.77-.45l.567-.291.516-.259c2.54-1.33 5.985-1.56 9.477-.975l.115.02.643.134c.408.084.697.129.958.14.482.022.64-.045.734-.238l.97-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 32.5,
    r: 29,
    stroke: "#FFF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 32.5,
    r: 30.15,
    stroke: "#C1ECF8",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 32.5,
    r: 30.5,
    stroke: "#20B8E9",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.4a6e1851a344d29ef995f8d238f2019b.svg";
export { ForwardRef as ReactComponent };